import { Form, Formik } from 'formik';
import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import { axiosInstance } from 'hb-react/shared/utils/axios';

const Gateway = (props) => {
  const [isLoading, setLoading] = useState(false);

  const {
    currency,
    amount,
    endpoint,
    payload,
    onSuccess,
    onCancel,
    payment: { gateway },
  } = props;

  const onSubmit = async (values) => {
    setLoading(true);

    try {
      const { data } = await axiosInstance.post(endpoint, values);

      setLoading(false);

      onSuccess(data);
    } catch {
      setLoading(false);
    }
  };

  const debug = String.raw`${gateway} ${endpoint} ${amount} ${
    currency?.code || currency
  }
${JSON.stringify(payload, undefined, 2)}`;

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        ...payload,
        billing: {
          gateway,
          transaction_token: 'pm_card_success',
        },
      }}
    >
      <Form style={{ width: '100%' }}>
        <Box
          justifyContent="space-between"
          data-testid="payment-provider-container"
          width="100%"
          flexDirection="column"
        >
          <Debug>{debug}</Debug>
          <Box justifyContent="space-between" mt={2}>
            <Button onClick={() => onCancel()}>onCancel</Button>
            <Button type="submit" isLoading={isLoading}>
              {__('Pay %{currency} %{amount}').i__({
                currency: currency?.code || currency,
                amount: Number(amount).toFixed(2),
              })}
            </Button>
          </Box>
        </Box>
      </Form>
    </Formik>
  );
};

const PaymentFakeGateway = ({ displayInModal = false, ...props }) => {
  if (displayInModal) {
    return (
      <ModalWithTemplate
        onCloseModal={props?.onCancel}
        header="Payment Gateway Mock"
      >
        <Gateway {...props} />
      </ModalWithTemplate>
    );
  }

  return <Gateway {...props} />;
};

export default PaymentFakeGateway;

const Debug = styled.pre`
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  padding: 4px;
  white-space: pre-wrap;
  color: #83ba52;
  background: #1b1b1b;
  font-size: 12px;
  line-height: 20px;
  border-radius: 8px;
  overflow: scroll;
  height: 300px;
`;
